
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[slug]",
      function () {
        return require("private-next-pages/education/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[slug]"])
      });
    }
  